import { ButtonLink } from '../ui/Button';

const points = [
  'Customised learning built around your business goals, not a fixed syllabus',
  'In-person workshops, virtual sessions, or a blended approach',
  'Recognised certification on successful completion',
];

export default function CorporateTraining() {
  return (
    <section className="bg-white">
      <div className="section-shell">
        <div className="grid items-center gap-10 overflow-hidden rounded-5xl bg-brand-900 p-8 sm:p-12 lg:grid-cols-[1.1fr_0.9fr] lg:p-14">
          <div className="text-white">
            <span className="inline-flex items-center gap-2 rounded-full bg-flare-400/20 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-flare-200">
              For employers
            </span>
            <h2 className="mt-4 text-3xl text-white sm:text-4xl">
              Upskill your workforce with tailored ICT programmes
            </h2>
            <p className="mt-4 max-w-lg text-base leading-relaxed text-white/65">
              We build ICT learnerships and skills programmes around the
              specific gaps in your team. Municipalities, law firms, and
              corporate clients already run their training with us.
            </p>

            <ul className="mt-7 space-y-3">
              {points.map((point) => (
                <li
                  key={point}
                  className="flex items-start gap-3 text-sm text-white/80"
                >
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-flare-400 text-brand-950">
                    <svg
                      className="h-3 w-3"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="m4 12 5 5L20 6" />
                    </svg>
                  </span>
                  {point}
                </li>
              ))}
            </ul>

            <ButtonLink to="/contact" variant="flare" size="lg" className="mt-9">
              Talk to us about group training
            </ButtonLink>
          </div>

          <div className="relative">
            <div className="rounded-4xl bg-white/5 p-6 backdrop-blur-sm">
              <div className="rounded-3xl bg-white p-5 shadow-float">
                <p className="text-sm font-bold text-brand-950">
                  Delivery options
                </p>

                <ul className="mt-4 space-y-3">
                  {[
                    { mode: 'In-person workshops', note: 'On site or at our facility' },
                    { mode: 'Virtual sessions', note: 'Facilitated remotely' },
                    { mode: 'Blended learning', note: 'Mix of both, scheduled around shifts' },
                  ].map((row) => (
                    <li
                      key={row.mode}
                      className="flex items-start gap-3 rounded-2xl bg-canvas-100 p-3.5"
                    >
                      <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-brand-100 text-brand-700">
                        <svg
                          className="h-3.5 w-3.5"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          aria-hidden="true"
                        >
                          <path d="m4 12 5 5L20 6" />
                        </svg>
                      </span>
                      <span>
                        <span className="block text-sm font-bold text-brand-950">
                          {row.mode}
                        </span>
                        <span className="block text-xs text-brand-900/55">
                          {row.note}
                        </span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
